import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import { Input, Typography, Menu,  Avatar, Modal, Button, List, message as mymessage, Dropdown } from 'antd';
import { AudioOutlined, PhoneOutlined, VideoCameraOutlined, InfoCircleOutlined, UserOutlined, MessageOutlined, MoreOutlined } from '@ant-design/icons';
import './chat.css';
import Message from './message';
import { resolve } from 'path';
import { SignalRContext } from '../../contexts/SignalRContext';
import Calling from '../calling/Calling';
import * as signalR from '@microsoft/signalr';
import { MessageActions } from '../messageAction/MessageAction';
import { error } from 'console';
const { TextArea } = Input;
const { Text } = Typography;
//const signalR = require('@microsoft/signalr');
const initialMsg = [
  { id: 0, email: '', sender: '', avatar: '', content: '', time: '', sent: false,
    url: '', fileName: '', status:'', groupId: 0
   },
];
type NvcmisChatProp = {
  groupId: number,
  createdUser: string,
  groupArr: {userName: string,
  email: string,
  userAvatar: string,
  isGroup: boolean
  }[]
}
const NvcmisChat = (props: NvcmisChatProp) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const messageRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const signalContext = useContext(SignalRContext);
  const [pinnedMessage, setPinnedMessage] = useState<any>(null)
  const connection = signalContext?.connection;
  const [displayGroupDetail, setDisplayGroupDetail] = useState(false);
  const [searchUsers, setSearchUsers] = useState<any>([]);
  const token = localStorage.getItem('token');
const [file, setFile] = useState<File|null>(null);
const [isModalFindMemberOpen, setIsModalFindMemberOpen] = useState(false);
const [messages, setMessages] = useState(initialMsg);
const [listUserOnGroup, setListUserOnGroup] = useState<any[]>([])
const [totalPages, setTotalPages] = useState(1);
const [page, setPage] = useState(1);
const [senderConnectionId, setSenderConnnectionId] = useState("");
const [message, setMessage] = useState<string>('');
const [group, setGroup] = useState(props.groupId.toString());
const scrollToMessage = (id: string) => {
    messageRefs.current[id]?.scrollIntoView({ behavior: 'smooth',
  block: 'center',
  inline: 'nearest' });
};
const menu = (
    <Menu>
      <Menu.Item key="1">Sao chép</Menu.Item>
      <Menu.Item key="2" onClick={()=>{
          fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/messages/pin/' + pinnedMessage.id
          + '/' + false, {
            method:'PUT',
            headers:{
                'Authorization': `Bearer ${localStorage.getItem('token')??''}`
            }
            })
          .then(response=>response.json())
          .then(data=>{
              if(data.message == 'Pinned'){
                  mymessage.info('Bạn đã bỏ ghim tin nhắn');
                  setPinnedMessage(null);
              }
          })
          .catch(error=>console.log(error));
      }}>Bỏ ghim</Menu.Item>
    </Menu>
  );
    const getTotalMessages = async (id: number): Promise<number> => {
      return new Promise((resolve, reject)=>{
        fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/totalmessages/' + id + '/' + localStorage.getItem('emailData') + '/10', {
          method: 'GET',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          }
        }).then(async(response)=>{
            if (response.status==401) {
                resolve(0);
            }
            else  {
              try{
                  let data = await response.json();
                  resolve(data);
              }
              catch{
                resolve(0);
              }       
            }
        })
        .catch(errors=>console.log(errors));
      })           
    }
    const getUsersByGroupId = (groupId: number) => {
      fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/User/' + groupId)
      .then(response=>response.json())
      .then(data=>setListUserOnGroup(data))
      .catch(errors=>console.log(errors));
    }
    const simulateApiCall = async (page: number, numberOfItem: number): Promise<any> => {
      return new Promise((resolve)=>{
        if(page!=0)
        fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/messages/' + group + '/' + localStorage.getItem('emailData') 
        + '/' + page + '/' + numberOfItem, {
          method: 'GET',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          }
        })
        .then(async (response) =>{
          if (!response.ok) {
                if (response.status === 401) {
                    localStorage.clear();
                    connection?.stop();
                    window.location.reload();
                }
                return null; // <=== Explicitly return a safe value
            }
            try {
                return await response.json();
            } catch (err) {
                    console.error("Invalid JSON in response");
                    return null; // Safe fallback
        }
        })
        .then((data:any)=>{
          let newMessages:any = [];
          data.map((item:any)=>{
            const myLocalDate = new Date(item.sentDate);
            const fileName = item.id + item.messageContent.substring(item.messageContent.lastIndexOf('.'));
            newMessages.push({
                groupId: item.groupId,
                id: item.id,
                email: item.email,
                sender: item.fullName, /*avatar: props.groupArr.filter(x=>x.email == item.email)[0].userAvatar,*/
                avatar: item.avatar, 
                content: item.messageContent, 
                url: item.fileData != ""?item.fileData:fileName,
                fileName: fileName,
                time: myLocalDate.toLocaleString(), sent: item.sent,
                status: item.seenUsers.length > 0 ? "Đã xem" : "Đã gởi",
                isPinned: item.isPined
            })
          })
          resolve(newMessages);
        });
        else
          resolve([]);
      })    
    }; 
      const handleSendMessage = async () => {
        if(connection){
          if(props.groupArr[0].isGroup){
              await connection?.invoke("SendMessageToGroup", group, message, localStorage.getItem('emailData'));
          }
          else{
              let receiver:string = props.groupArr.filter(x=>x.email!=localStorage.getItem('emailData'))[0].email;
              await connection?.invoke("SendMessagePrivate", group, message, localStorage.getItem('emailData'), receiver)
          }   
          setMessage('');
          setMessages((prevMessages:any) => {
        let fullName = ''; let imageData = '';         
        const newMessage = {
            groupId: Number(group),
            id: 0,
            email: localStorage.getItem('emailData'),
            sender: fullName,
            avatar: imageData,  // Provide a default value if Avatar is null
            content: message,
            time: 'just now',
            sent: true,
            url: '',
            fileName: '',
            status: "Đã gởi"
        };  
        if (prevMessages.length > 0) {
            const lastMessage = prevMessages[prevMessages.length - 1];
            if (lastMessage) {
                newMessage.sent = lastMessage.email !== localStorage.getItem('emailData') ? !lastMessage.sent : lastMessage.sent;
            }
        } 
        return [...prevMessages, newMessage];
    })
        }
      }
      const handleSendFile = async () => {
        if(file){
          const form = new FormData();
          form.append('MessageContent', file.name);
          form.append('FileAttact', file);
            fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/sendfile/' + group + '/' + localStorage.getItem('emailData'),{
              method:'POST',
              headers:{
                'Authorization': `Bearer ${token}`
              },
              body: form
            })
            .then(async (response)=>{
                if (!response.ok) {
                if (response.status === 401) {
                    localStorage.clear();
                    connection?.stop();
                    window.location.reload();
                }
                return null; // <=== Explicitly return a safe value
            }

            try {
                return await response.json();
            } catch (err) {
                    console.error("Invalid JSON in response");
                    return null; // Safe fallback
        }
            })
            .then(data=>{
              console.log(data);
              if (connection) {
                try {
                  if(props.groupArr[0].isGroup)
                    connection.invoke("SendFileToGroup", data, group, localStorage.getItem('emailData'));
                  else{
                    //alert('chạy vào đây');
                    let receiver:string = props.groupArr.filter(x=>x.email!=localStorage.getItem('emailData'))[0].email;
                    connection.invoke("SendFilePrivate", data, group, localStorage.getItem('emailData'), receiver);
                  }
                  setMessage('');
                } catch (err:any) {
                    console.error("Send message failed: ", err.toString());
                }
            }
            })
        };     
      }     
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
    const handleReceiveFile = (msg: string, email:string, url:string, id:number, groupId: string) => {
      if(props.groupId.toString()==groupId){
        setMessages((prevMessages) => {
        let fullName = ''; let imageData = '';         
        const content = msg;
        const newMessage = {
            groupId:Number(groupId),
            id: id,
            email: email,
            sender: fullName,
            avatar: imageData,  // Provide a default value if Avatar is null
            content: content,
            time: 'just now',
            sent: true,
            url: url,
            fileName: content,
            status: "Đã gửi"
        };  
        if (prevMessages.length > 0) {
            const lastMessage = prevMessages[prevMessages.length - 1];
            if (lastMessage) {
                newMessage.sent = lastMessage.email !== email ? !lastMessage.sent : lastMessage.sent;
            }
        } 
        return [...prevMessages, newMessage];
    })
      }
    };
    const handleReceiveMessage = (msg: string, email:string, messageId: number, groupId:string) => {    
      if(props.groupId.toString()==groupId){
        setMessages((prevMessages) => {
        let fullName = ''; let imageData = '';         
        const content = msg;
        const newMessage = {
            groupId: Number(groupId),
            id: messageId,
            email: email,
            sender: fullName,
            avatar: imageData,  // Provide a default value if Avatar is null
            content: content,
            time: 'just now',
            sent: true,
            url: '',
            fileName: '',
            status: "Đã gởi"
        };  
        if (prevMessages.length > 0) {
            const lastMessage = prevMessages[prevMessages.length - 1];
            if (lastMessage) {
                newMessage.sent = lastMessage.email !== email ? !lastMessage.sent : lastMessage.sent;
            }
        } 
        return [...prevMessages, newMessage];
    })
  }
};
    const audioRef = useRef<HTMLAudioElement | null>(null);
    useEffect(() => {
      if (isModalOpen) {
        audioRef.current = new Audio("/sounds/Chi-Co-Em-Quoc-Dai.mp3");
        audioRef.current.play().catch((err) => console.error("Error playing sound:", err));
      } else {
        if (audioRef.current) {
          audioRef.current.pause(); // Pause the audio
          audioRef.current.currentTime = 0; // Reset to the beginning
        }
      }
    }, [isModalOpen]);
    useEffect(() => {
      if(connection){
        connection.invoke("JoinGroup", group);
        // Register the event handler for receiving messages
        connection.on("ReceiveCallRequest", (fullName:string, email:string)=>{
            setIsModalOpen(true);
        })
        //connection.off("ReceiveMessage", handleReceiveMessage);
        connection.on("ReceiveMessage", handleReceiveMessage);  
        connection.on("ReceiveMessagePrivate", handleReceiveMessage)      
        connection.on("ReceiveSeenStatus", (msg: number, email:string) => {
          setMessages(prevList => {
            const index = prevList.findIndex(x=>x.id == msg && x.email != email);
            if (index > -1) {
              const updatedMsg = { ...prevList[index], status: "Đã xem" };
              return [
                ...prevList.slice(0, index),
                updatedMsg,
                ...prevList.slice(index + 1)
              ];
            }
            return prevList;
          });
        });
        //connection.off("ReceiveFile", handleReceiveFile);
        connection.on("ReceiveFile", handleReceiveFile);
        connection.on("ReceiveFilePrivate", handleReceiveFile);
      }
      const myPromis = new Promise<number>((resolve)=>{
          getTotalMessages(props.groupId)
          .then((data:number)=>{
            resolve(data);
          })
        })
        .then((data)=>{
          if(data==0){
              localStorage.clear();
              //connection?.stop();
              //window.location.reload();
          }
          else
             fetchInitialItems(data);
        })
    }, [group]);
    const handleAddMember = (email:string) => {
      fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/GroupUser/groupuser/' + 
        props.groupId + '/' + localStorage.getItem('emailData') + '/' + email,{
          method:'POST',
          headers: {
              'Authorization': `Bear ${token}`
          }
        }).then(response=>response.json())
        .then(data=>{
            if(data.message=="Added")
                getUsersByGroupId(props.groupId);
        })
        .catch(errors=>console.log(errors));
    };
    const fetchInitialItems = async (data:number) => {
      const newItems = await simulateApiCall(data, 10);
      await fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/messages/pinned/' + props.groupId, {
        method:'GET',
        headers: {
          'Authorization':`Bearer ${token}`
        }
      })
      .then(response=>response.json())
      .then(data=>setPinnedMessage(data))
      .catch(error=>console.log(error));
      setMessages(newItems);
      setPage(data-1); 
      // Scroll to the bottom of the div after the initial items are loaded
      setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
      }, 0);
    };  
    // Fetch more items when scrolling up
    const fetchMoreItems = async (status: boolean) => {
      if (page < 1) return; // Stop fetching if page is greater than 10
      const newItems = await simulateApiCall(page, 10); 
      // Keep track of the current scroll position before appending new items
      const container = containerRef.current;
      const previousScrollHeight = container?.scrollHeight ?? 0;        
      if(!status){
            setMessages((prevItems) => [...newItems, ...prevItems]);
            setPage((prevPage) => prevPage - 1);
      }
      else{
            setMessages((prevItems) => [...prevItems, ...newItems]);
            setPage((prevPage) => prevPage + 1);
      }
      // Maintain the user's scroll position after new items are added
      setTimeout(() => {
        if (container) {
          container.scrollTop = container.scrollHeight - previousScrollHeight;
        }
      }, 0);
    };
    const handleScroll = () => {
      const container = containerRef.current;
      if (container) {
        //const isBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;
        if (container.scrollTop === 0 && page >= 1) {
          fetchMoreItems(false);
        }
        // if(isBottom){
        //   fetchMoreItems(true);
        // }
      }
    };
  const handleGroupDetail = ()=>{
        getUsersByGroupId(props.groupId);
        setDisplayGroupDetail(!displayGroupDetail);
  }
  
  useEffect(()=>{
    if(containerRef.current){
      const container = containerRef.current;
      if(container.scrollHeight <= container.clientHeight){
        fetchMoreItems(false);
      }
    }
  },[messages])
    useEffect(()=>{
      console.log(props);
      setMessages(initialMsg);
      setGroup(props.groupId.toString()); 
    },[props.groupId]);
  return (
    <div className="chat-container">
      <div className="chat-header">
        <Avatar src={props.groupArr[0].userAvatar} />
        <div className="chat-header-info">
          <h3>{props.groupArr[0].userName}</h3>
          <span></span>
        </div>
        <div className="chat-header-actions">
          <PhoneOutlined />
          <VideoCameraOutlined />
          <AudioOutlined 
          onClick={()=>{
            setIsModalOpen(true);
            fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Call/getConnectionId/' + props.groupArr[0].email,{
              method:'GET',
              headers:{
                'Authorization': `Bearer ${token}`
              }
            })
            .then(response=>response.json())
            .then(data=>{
              if(data.message != null){
                setSenderConnnectionId(data.message);
                connection?.invoke("CallUser", data.message, localStorage.getItem("userFullName")??"", localStorage.getItem("emailData")??"")
            }}
            )
          }}
          />
          <InfoCircleOutlined onClick={handleGroupDetail} />
        </div>
      </div>
    {pinnedMessage !=null ?
    <div className="message-notification" onClick={async()=>{
      if(messages.findIndex(x=>x.id==pinnedMessage.id)>-1){
          scrollToMessage(pinnedMessage.id);
      }
      else{
          const newItems = await simulateApiCall(Number(pinnedMessage.fileData), (page - Number(pinnedMessage.fileData))*10); 
          setMessages(previous=>[...newItems, ...previous]);
          setPage(page - Number(pinnedMessage.fileData));
      }
    }}>
      <Avatar icon={<MessageOutlined />} className="message-avatar" />
      <div className="message-content">
        <Text strong>{'Tin nhắn được ghim: '}</Text>
        <Text className="message-preview">{pinnedMessage.messageContent}</Text>
      </div>
      <Dropdown overlay={menu} trigger={['click']}>
        <MoreOutlined className="message-more" />
      </Dropdown>
    </div>:null}
      <div className='chat-messages-groupdetail'>      
      <div ref={containerRef} onScroll={handleScroll} className="chat-messages">
        {
        messages.map((msg, index) => {           
          return  (
            <MessageActions key={index} messageDetail={msg} groupId={Number(group)} connnection={connection} 
            ref={(el:any) => (messageRefs.current[msg.id] = el)}
            />
        )})
      }
      </div>
      {displayGroupDetail?(props.groupArr[0].isGroup)?
      <div className='group-detail'>
        <h3>Danh sách thành viên nhóm {(props.createdUser == localStorage.getItem('emailData'))?
        <img style={{width:'20px', height:'20px'}} 
        onClick={()=>setIsModalFindMemberOpen(true)} src='/images/Add.png' />:null}</h3>
          <List style={{width:'100%'}}
        itemLayout="horizontal"
        dataSource={listUserOnGroup}
        renderItem={(user:any) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={user.imageDataURL || null} />}
              title={<div><a onClick={()=>{
                
                }}>
              {user.fullName}</a>&nbsp;{(props.createdUser == localStorage.getItem('emailData'))?
              <Button onClick={()=>{
                  fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/GroupUser/' + 
        props.groupId + '/' + user.email,{
          method:'DELETE',
          headers: {
              'Authorization': `Bear ${token}`
          }
        }).then(response=>response.json())
        .then(data=>{
            if(data.message=="Deleted")
                getUsersByGroupId(props.groupId);
            else
                console.log(data.message);
        })
        .catch(errors=>console.log(errors));
              }}>Xóa khỏi nhóm</Button>:null}</div>}
            />           
          </List.Item>
        )}
      />
      </div>:null:null}
      </div>
      <div className="chat-input">
        <input style={{width:'30%'}} type='file' onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
          }
        }} /><button style={{width:'145px'}} onClick={handleSendFile}>Send file</button>
        <Input value={message}
        onChange={(e)=>setMessage(e.currentTarget.value)}
        onKeyDown={(e)=>{
            if(e.key == 'Enter'){
                handleSendMessage();
            }
        }} />
      </div>
      <Modal
  title="Calling...."
  open={isModalOpen}
  onOk={handleOk}
  onCancel={handleCancel}
  footer={null} // Hide the default footer buttons
  width={400}  // Set a fixed width
  style={{ top: 50 }} // Position the modal nicely
  bodyStyle={{ height: 500, padding: 0 }} // Set height and remove padding
>
  <div style={{ width: "100%", height: "100%" }}>
    <Calling connectionId={senderConnectionId} />
  </div>
</Modal>
<Modal
  title="Tìm thành viên"
  open={isModalFindMemberOpen}
  onCancel={()=>setIsModalFindMemberOpen(false)}
  width={400}  // Set a fixed width
  style={{ top: 50 }} // Position the modal nicely
  bodyStyle={{ height: 500, padding: 0 }} // Set height and remove padding
>
  <Input size="large" placeholder="large size" prefix={<UserOutlined />} 
      onChange={(e)=>{
        fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/User/user/' + e.currentTarget.value)
        .then(response=>response.json())
        .then(data=>{
          if (Array.isArray(data)) {
          setSearchUsers(data);
        } else {
          console.warn('API không trả về mảng:', data);
          setSearchUsers([]);
        }
        })
        .catch(errors=>console.log(errors))
      }}
  />
  <List style={{width:'100%'}}
        itemLayout="horizontal"
        dataSource={searchUsers}
        renderItem={(user:any) => (
          <List.Item>
            <List.Item.Meta
              //avatar={<Avatar src={user.imageDataURL || null} />}
              title={<div><a onClick={()=>{
                
                }}>
              {user.fullName}</a>&nbsp;<Button onClick={()=>handleAddMember(user.email)}>Thêm</Button></div>}
            />           
          </List.Item>)}
  />
</Modal>
    </div>
  );
};
export default NvcmisChat;
